// extracted by mini-css-extract-plugin
module.exports = {"basePrice":"m5YiNL"};